import type { InfosecStorageUnit } from '../../pages/computers-page/infosec-procedure/infosecStorageUnit';

export const mappedRemoteServers = (computers): InfosecStorageUnit[] =>
  computers
    .filter((item) => {
      return !item.deleted && item.unitType === 'remoteServer';
    })
    .map((item) => {
      return {
        uuid: item.uuid,
        name: item.name ?? '',
        unitType: 'remoteServers',
        computerType: '',
        application: '',
        partnerUuid: item.serviceProvider ?? '',
        networkUuid: item.networkUuid ?? '',
      };
    });
